import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  toggled: "dibt142kiyi"
});
const checkmark = "dibcvpqsnb";

export { checkmark, modifiers };
import "./checkmark.style.linaria.module.css";
//# sourceMappingURL=checkmark.style.js.map
